const trackEligibilityCodeExtra = () => null;

export default trackEligibilityCodeExtra;
